import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getWorkShifts = () => {
    return request({
        url: namespace + "/workshifts",
        method: "get",
    });
};

export const getWorkShift = (ws_id) => {
    return request({
        url: namespace + "/workshift/" + ws_id,
        method: "get",
    });
};

export const getWorkShiftUser = (user_id) => {
    return request({
        url: namespace + "/workshift/user/" + user_id,
        method: "get",
    });
};

export const createWorkShift = (payload) => {
    return request({
        url: namespace + "/workshift",
        data: payload,
        method: "post",
    });
};

export const updateWorkShift = (ws_id, payload) => {
    return request({
        url: namespace + "/workshift/" + ws_id,
        data: payload,
        method: "put",
    });
};

export const destroyWorkShift = (ws_id) => {
    return request({
        url: namespace + "/workshift/" + ws_id,
        method: "delete",
    });
};

export const linkCycle = (payload, user_id) => {
    return request({
        url: namespace + "/workshift/user/" + user_id,
        data: payload,
        method: "post",
    });
};

export const unlinkCycle = (user_id, workshift_user_id) => {
    return request({
        url: namespace + "/workshift/user/" + user_id + "/" + workshift_user_id,
        method: "delete",
    });
};

export const updateCycle = (payload, user_id, workshift_user_id) => {
    return request({
        url: namespace + "/workshift/user/" + user_id + "/" + workshift_user_id,
        data: payload,
        method: "post",
    });
};

export const createPlanning = (payload) => {
    return request({
        url: namespace + "/planning/create",
        data: payload,
        method: "post",
    });
};

export const deletePlanning = (payload) => {
    return request({
        url: namespace + "/planning/delete",
        data: payload,
        method: "delete",
    });
};

export const createPlanningReal = (payload) => {
    return request({
        url: namespace + "/planning/real",
        data: payload,
        method: "post",
    });
};

export const cancelPlanningReal = (payload) => {
    return request({
        url: namespace + "/planning/real/cancel",
        data: payload,
        method: "post",
    });
};

export const recalculatePlanningCounters = (payload) => {
    return request({
        url: namespace + "/planning/counters/recalculate",
        data: payload,
        method: "post",
    });
};
